import { Reveal, SectionHeading } from "../Reveal";

const STEPS = [
  { n: "01", title: "تواصل معنا", desc: "اتصل أو أرسل واتساب على 0508769282 في أي وقت — ليلًا أو نهارًا." },
  { n: "02", title: "أرسل موقعك", desc: "شاركنا اللوكيشن من جوجل ماب ليصلك الفني بدقة وبدون اتصالات متكررة." },
  { n: "03", title: "أخبرنا بالمشكلة", desc: "بنشر؟ بطارية؟ كفر منفجر؟ وضّح لنا المشكلة لنجهّز المعدات والقطع المناسبة." },
  { n: "04", title: "نصل إليك", desc: "ينطلق الفني فورًا إلى موقعك ويصلح المشكلة أمامك، وتكمل طريقك بأمان." },
];

export const HowItWorks = () => (
  <section id="how" data-testid="how-section" className="py-24 bg-[#0d0d0f] border-y border-[#1c1c20]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          kicker="كيف نعمل"
          title="أربع خطوات وتكمل طريقك"
          desc="طلب الخدمة من نجم الإطارات أبسط مما تتخيل."
        />
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div data-testid={`how-step-${s.n}`} className="relative">
              <div className="font-display text-outline text-7xl font-extrabold leading-none mb-4">{s.n}</div>
              <div className="h-px w-full bg-gradient-to-l from-yellow-400/60 to-transparent mb-4" />
              <h3 className="font-display text-xl font-bold text-white mb-2">{s.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
